/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var AccountingLocationStatusType;
(function (AccountingLocationStatusType) {
    AccountingLocationStatusType["NO_COMPANY"] = "no_company";
    AccountingLocationStatusType["NO_COMPANY_ACCESS"] = "no_company_access";
    AccountingLocationStatusType["NO_GL_MAPPING"] = "no_gl_mapping";
    AccountingLocationStatusType["LOST_STORES"] = "lost_stores";
    AccountingLocationStatusType["EXPIRED_CADENCE"] = "expired_cadence";
    AccountingLocationStatusType["OK"] = "ok";
})(AccountingLocationStatusType || (AccountingLocationStatusType = {}));
